<template>
  <div class="analytics-grid">
    <ChartCard v-for="chart in charts" :key="chart.title" v-bind="chart" />
  </div>
</template>

<script>
import ChartCard from "./ChartCard.vue";
import { rankingBarChartOptions, shareDonutChartOptions } from "../dashboardCharts";

const amounts = (rows, field) => rows.map((row) => Number(row[field] || 0));

// Top items by revenue and profit, and revenue share by category (current month).
export default {
  name: "ItemAnalyticsSection",
  components: { ChartCard },
  props: {
    topItemsRevenue: { type: Array, required: true },
    topItemsProfit: { type: Array, required: true },
    categoryRevenue: { type: Array, required: true },
  },
  computed: {
    charts() {
      const categorySeries = amounts(this.categoryRevenue, "revenue");
      return [
        {
          title: "Top 5 items by revenue (this month)",
          subtitle: "Sales amount by item, not just units.",
          type: "bar",
          height: "330",
          series: [{ name: "Revenue", data: amounts(this.topItemsRevenue, "revenue") }],
          options: rankingBarChartOptions({
            labels: this.topItemsRevenue.map((row) => row.itemname),
            colors: ["#3b82f6", "#06b6d4", "#8b5cf6", "#f59e0b", "#10b981"],
          }),
          hasData: this.topItemsRevenue.length > 0,
          emptyText: "No revenue data yet.",
        },
        {
          title: "Top 5 items by profit",
          subtitle: "Revenue minus FIFO cost price per item.",
          type: "bar",
          height: "330",
          series: [{ name: "Profit", data: amounts(this.topItemsProfit, "profit") }],
          options: rankingBarChartOptions({
            labels: this.topItemsProfit.map((row) => row.itemname),
            colors: ["#10b981", "#14b8a6", "#84cc16", "#f97316", "#6366f1"],
          }),
          hasData: this.topItemsProfit.length > 0,
          emptyText: "No profit data yet.",
        },
        {
          title: "Category Revenue",
          subtitle: "Revenue split by item category for the current month.",
          type: "donut",
          height: "330",
          series: categorySeries,
          options: shareDonutChartOptions({
            labels: this.categoryRevenue.map((row) => row.categoryname),
            series: categorySeries,
          }),
          hasData: this.categoryRevenue.length > 0,
          emptyText: "No category revenue data yet.",
        },
      ];
    },
  },
};
</script>
